import { useRouter } from 'next/router';
import { PATHS, SEARCH_PATHS } from '@belong/common';
import { Link } from '@belong/ui';
import type {
  ButtonPartialResponsiveSize as PartialResponsiveSize,
  ButtonSize as Size,
  ButtonVariantTypes as VariantTypes,
} from '@belong/ui';
import queryString from 'query-string';

const ActionTypes = {
  Document: 'Document',
  Web: 'Web',
};

const ActionNames = {
  Calculator: 'calculator',
  HowItWorks: 'how-it-works',
  LeadModal: 'show-lead-modal',
};

type LinkProps = { size?: Size | PartialResponsiveSize } & VariantTypes;

export type ButtonPrismicAdapterAction = {
  link_type: string;
  slug: string;
  uid?: string;
  url?: string;
  data?: {
    body?: { slice_type: string; primary: { key: string; value: string } }[];
    title?: string;
    subtitle?: string;
  };
};

type ButtonPrismicAdapterProps = {
  action: ButtonPrismicAdapterAction;
  label: string;
} & LinkProps;

export function ButtonPrismicAdapter({
  action,
  label,
  ...rest
}: ButtonPrismicAdapterProps): JSX.Element {
  const router = useRouter();
  const { link_type, slug, uid, url, data } = action;

  // Dynamic props added thru the key_value_pair slice in prismic.
  const extraProps = data?.body?.reduce<Record<string, unknown>>((acc, val) => {
    if (val.slice_type === 'key_value_pair') {
      acc[val.primary.key] = val.primary.value;
    }
    return acc;
  }, {});

  const buttonProps: { href: string } & Record<string, unknown> = { href: '' };

  if (link_type === ActionTypes.Document) {
    if (slug === ActionNames.Calculator) {
      buttonProps.href = PATHS.RENT_ESTIMATE_FLOW;
    } else if (slug === ActionNames.HowItWorks) {
      buttonProps.href = `${router.pathname}?${SEARCH_PATHS.HOW_IT_WORKS}`;
    } else if (slug === ActionNames.LeadModal) {
      const query = queryString.stringify({
        activeModal: 'ASK_A_QUESTION',
        title: data?.title,
        subtitle: data?.subtitle,
        source: 'JoinWaitlist',
        ...extraProps,
      });
      buttonProps.href = `${router.pathname}?${query}`;
    } else {
      buttonProps.href = `/blog/${uid}`;
    }
  } else if (link_type === ActionTypes.Web) {
    buttonProps.href = url?.replace('https://belonghome.com', '') || ''; // NOTE: the url can be external
  }

  return (
    <Link {...buttonProps} {...rest}>
      {label}
    </Link>
  );
}
